import React, { useState, useEffect, useContext } from "react";
import { CommonContext } from "contexts/CommonContext";

interface TimerProps {
  resendOTPTime: number;
}

const Timer: React.FC<TimerProps> = ({ resendOTPTime }) => {
  const { setIsResendOtpClicked } = useContext(CommonContext);
  const [timeRemaining, setTimeRemaining] = useState(resendOTPTime);

  useEffect(() => {
    if (timeRemaining > 0) {
      const timerId = setInterval(() => {
        setTimeRemaining((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timerId);
    }
    if (timeRemaining === 0) {
      setIsResendOtpClicked && setIsResendOtpClicked(false);
    }
  }, [timeRemaining,setIsResendOtpClicked]);


  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const remainingSeconds = time % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  return <>{formatTime(timeRemaining)}</>;
};

export default Timer;
